<template>
  <div class="cashea-pay-warp">
    <div id="cashea-checkout-container"></div>
  </div>
</template>

<script>
import CheckoutSDK from "cashea-web-checkout-sdk";

export default {
  data () {
    return {
      cashea: null,
      payload: null
    }
  },
  methods: {
    loadPay () {
      let _this = this
      _this.cashea.createCheckoutButton({
        payload: this.payload,
        container: document.getElementById("cashea-checkout-container")
      })
    }
  },
  created () {
    const jsonStr = decodeURIComponent(escape(atob(this.$route.query.payload)))
    this.payload = JSON.parse(jsonStr)
    let publicKey = this.$route.query.publicKey
    this.cashea = new CheckoutSDK({ apiKey: publicKey })
  },
  mounted () {
    this.loadPay()
  }
}
</script>

<style lang="less" scoped>
.cashea-pay-warp{
  background-color: #fff;
  padding: 50px;
}
</style>
